export default "__VITE_ASSET__BxTOkADU__"